import { z } from "zod";
import { PropertyBankSchema } from "./ShowBankResponse";
import { RegionSchema } from "../../region/response/RegionResponse";

const PivotSchema = z.object({
    property_id: z.string().uuid(),
    user_id: z.string().uuid(),
    is_active: z.number(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});

const UserSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    email: z.string().email(),
    email_verified_at: z.string().datetime().nullable(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
    channex_user_api_key: z.string().nullable(),
    username: z.string().nullable(),
    phone: z.string(),
    pivot: PivotSchema,
});

const BankSchema = PropertyBankSchema;

export const PropertySchema = z.object({
    id: z.string().uuid(),
    // Nullable: a deactivated property (Property Management "Status" switch)
    // has its Channex mapping deleted, which nulls channex_id server-side
    // (DeactivatePropertyChannexJob). Without `.nullable()` here, the entire
    // property list page throws on the very first deactivated property.
    channex_id: z.string().uuid().nullable(),
    name: z.string(),
    accommodation_type: z.number(),
    preferred_currency: z.string(),
    time_zone: z.string(),
    primary_email: z.string().email(),
    cc_emails: z.array(z.string().email()).nullable(),
    accounting_email: z.string().email().nullable(),
    mobile_number_country_code: z.nullable(z.string()),
    mobile_number: z.nullable(z.string()),
    enable_cvv: z.coerce.number(),
    primary_phone_country_code: z.string().nullable(),
    primary_phone: z.string().nullable(),
    website: z.string().url().nullable(),
    email_autofill: z.union([z.string().email().nullable(), z.null()]).optional(),
    country: z.string().nullable(),
    state: z.string().nullable(),
    city: z.string().nullable(),
    street_address: z.string().nullable(),
    postal_code: z.string().nullable(),
    prefix_booking_number: z.string().nullable(),
    hotel_tax_number: z.string().nullable(),
    latitude: z.string().nullable(),
    longitude: z.string().nullable(),
    description: z.string().nullable(),
    term_condition: z.string().nullable().optional(),
    cancellation_policy: z.string().nullable().optional(),
    facebook_link: z.string().url().nullable(),
    instagram_link: z.string().url().nullable(),
    youtube_link: z.string().url().nullable(),
    tiktok_link: z.string().url().nullable(),
    logo: z.string().nullable(),
    cover_image: z.string().nullable(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
    is_full_sync: z.boolean(),
    // Flag activate/deactivate Channex (lihat IndexAi/property-management.md).
    // `.optional()` supaya FE tetap lolos validasi terhadap backend versi
    // lama yang belum mengirim field ini (deploy FE/BE tidak mengikat).
    is_property_active: z.boolean().optional(),
    property_type: z.string(),
    settings: z.any().nullable(),
    logo_url: z.string().nullable(),
    users: z.array(UserSchema).optional(),
    banks: z.array(BankSchema).optional(),
    billing_type: z.string().nullable().optional(),
    region_id: z.string().uuid().nullable().optional(),
    region: z.lazy(() => RegionSchema).nullable().optional(),
    checkin_time: z.string().nullable().optional(),
    checkout_time: z.string().nullable().optional(),
    // Active room count (status = available, i.e. excludes closed rooms) — used to
    // flag a billing_type that doesn't match the property's actual room inventory.
    active_rooms_count: z.number().optional(),
    // SUM of room_types.total_rooms — a second, independently-maintained source for
    // "how many rooms does this property have" that can drift from active_rooms_count
    // (see PropertyController::index). Sent so the UI can flag the two disagreeing.
    room_types_total_rooms: z.number().nullable().optional(),
    // Dev-only (property list): an ACTIVE billing connection covers this property, either
    // directly (B2C) or through the company that owns its group (B2B).
    billing_connected: z.boolean().optional(),
    billing_connected_via: z.enum(['property', 'company']).nullable().optional(),
});